import React from "react";
import { useParams } from "react-router-dom";

import { RedirectRoute } from "./components/RedirectRoute";
import { ProtectedRoute } from "./components/ProtectedRoute";
import routes from "../../routes";
import { accountTypeURIs } from "../../constants";

export const AccountTypeProtectedRoute = props => {
  const params = useParams();
  const { accountType } = params;
  if (!Object.keys(accountTypeURIs).includes(accountType)) {
    return <RedirectRoute to={routes.quickapplyLanding} />;
  }

  return <ProtectedRoute {...props} />;
};
